/* @ngInject */
export default function SelectedFiltersService(SideMenuCacheService, SleuthService, ContainerInfoApiService, CacheService) {
    function getFormattedValue(detectedParameterValue) {
        for (let i = 0; i < SideMenuCacheService.sidemenu.length; ++i) {
            if (SideMenuCacheService.sidemenu[i].parameterId === detectedParameterValue.parameterId) {
                for (let j = 0; j < SideMenuCacheService.sidemenu[i].parameterValues.length; ++j) {
                    if (SideMenuCacheService.sidemenu[i].parameterValues[j].id === detectedParameterValue.id) {
                        return SideMenuCacheService.sidemenu[i].parameterValues[j].formattedValue;
                    }
                }
            }
        }
        return detectedParameterValue.value;
    }

    function displayParameterName(filter) {
        return ContainerInfoApiService.getDisplayNameByParameterDisplayNames(filter.parameterDisplayNames, CacheService.getConfigurationInfo().language);
    }

    return {
        getFormattedValue: getFormattedValue,
        createSelectedFiltersFromSleuthData: function () {
            const selectedFilters = [];
            let found;
            if (SleuthService.getSleuthData()) {
                const queryParameterValues = SleuthService.getSleuthData().queryParameterValues;
                //if ( queryParameterValues !== undefined && Array.isArray(queryParameterValues) ) {
                for (var i = 0; i < queryParameterValues.length; i++) {
                    found = false;
                    if (queryParameterValues[i].formattedValue === undefined || queryParameterValues[i].formattedValue === null ||
                        queryParameterValues[i].formattedValue === queryParameterValues[i].value) {
                        queryParameterValues[i].formattedValue = getFormattedValue(queryParameterValues[i]);
                    }
                    for (var j = 0; j < selectedFilters.length; ++j) {
                        if (selectedFilters[j].name === queryParameterValues[i].parameterDisplayName) {
                            selectedFilters[j].parms.push(queryParameterValues[i]);
                            found = true;
                        }
                    }
                    if (!found) {
                        selectedFilters.push({
                            name: displayParameterName(queryParameterValues[i]),
                            parms: [queryParameterValues[i]]
                        });
                    }
                }
                //}
            }
            return selectedFilters;
        }
    };
}
